import React from 'react'

export const PaginationButton = (props) => {
    return (
      <button
        className={`${
          props.isActive
            ? "bg-primary font-semibold border-primary text-white"
            : "bg-white"
        } w-9 h-9 hover:border-primary duration-300 cursor-pointer border flex justify-center items-center rounded-md disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-[#eee]`}
        disabled={props.disabled}
        onClick={props.handleClick}
      >
        {props.item}
      </button>
    );
}
